export const ENVIRONMENT_NAME = '____FormBuilderData';
